import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { COMPANY, buildWhatsAppUrl } from "@/i18n";

export function buildContactCards(t) {
  return [
    {
      tid: "contact-whatsapp",
      icon: <MessageCircle className="w-5 h-5" />,
      label: t.whatsapp.label,
      value: t.whatsapp.value,
      href: buildWhatsAppUrl(t.whatsapp.prefilled),
      external: true,
    },
    {
      tid: "contact-phone",
      icon: <Phone className="w-5 h-5" />,
      label: t.contact.phone,
      value: COMPANY.phone,
      href: `tel:${COMPANY.phoneIntl}`,
    },
    {
      tid: "contact-email",
      icon: <Mail className="w-5 h-5" />,
      label: t.contact.email,
      value: COMPANY.email,
      href: `mailto:${COMPANY.email}`,
    },
    {
      tid: "contact-area",
      icon: <MapPin className="w-5 h-5" />,
      label: t.contact.area,
      value: t.contact.areaValue,
    },
    {
      tid: "contact-hours",
      icon: <Clock className="w-5 h-5" />,
      label: t.contact.hours,
      value: t.contact.hoursValue,
    },
  ];
}
